import { Link } from 'react-router-dom'
import SupplierRateCardsTab from './SupplierRateCardsTab'

// Z81: supplier (IN-rate / cost side) pricing. A first-level module of its own, not a tab of the
// customer Pricing page -- the two are symmetric systems (pricing_rate_cards <-> supplier_rate_cards).
// Access: ADMIN + ACCOUNTS read/write, OPERATIONS read-only (route in App.tsx, enforced by RLS).
export default function SupplierPricing() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <div className="mb-6">
          <Link to="/" className="text-sm text-blue-600 dark:text-blue-400 hover:underline">&larr; Dashboard</Link>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-1">Supplier Pricing</h1>
          <p className="text-gray-500 dark:text-gray-400 text-sm mt-0.5">What hauliers and couriers charge us — rate cards by supplier, delivery method and delivery postcode area.</p>
        </div>
        <SupplierRateCardsTab />
      </div>
    </div>
  )
}
